<template>
    <div id="administrator-dashboard">
        <b-overlay :show="showLoading" spinner-variant="primary">

            <b-card no-body>

                <b-card-title class="mt-2">

                    <b-row class="justify-content-md-center">

                        <b-col cols="12" md="auto">
                            <div class="d-flex justify-content-center align-items-center">
                                <feather-icon icon="CalendarIcon" size="30" />
                                <flat-pickr v-model="rangePicker" :config="{ mode: 'range' }"
                                    class="form-control flat-picker bg-transparent border-0 shadow-none"
                                    style="width: 150%;font-size: 20px;" placeholder="YYYY-MM-DD" />
                            </div>
                        </b-col>
                    </b-row>

                </b-card-title>

                <b-card-body>
                    <section id="dashboard-admin" :key="showDataKeys">
                        <b-row class="match-height">
                            <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>{{ culumnChartNumbersTitle }}</h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts type="line" height="400" :options="columnChartNumbers.chartOptions"
                                        :series="columnChartNumbers.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                            <b-col lg="12" sm="12">
                                <b-card no-body class="card-revenue-budget">
                                    <b-card-header>
                                        <b-col lg="12" sm="12">
                                            <h3>{{ columnChartAmountTitle }}</h3>
                                        </b-col>
                                    </b-card-header>
                                    <vue-apex-charts type="bar" height="400" :options="columnChartAmount.chartOptions"
                                        :series="columnChartAmount.series"></vue-apex-charts>
                                </b-card>
                            </b-col>
                        </b-row>
                    </section>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import {
    kFormatter
} from '@core/utils/filter'
import {
    $themeColors
} from "@themeConfig";
import VueApexCharts from "vue-apexcharts";
export default {
    components: {
        VueApexCharts,
        flatPickr
    },
    data() {
        return {
            culumnChartNumbersTitle: "Variation Quotidienne des Ventes Par Nombre de Commandes",
            columnChartAmountTitle: "Variation Quotidienne des Ventes Par Chiffre D'affaires",
            rangePicker: ['2019-05-01', '2019-05-10'],
            columnChartNumbers: {
                series: [{
                    name: 'Nombre Total',
                    data: []
                },],
                chartOptions: {
                    colors: [$themeColors.primary, $themeColors.secondary],
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 3,
                    },
                    chart: {
                        height: 350,
                        type: 'line',
                    },
                    forecastDataPoints: {
                        count: 7
                    },
                    // stroke: {
                    //     width: 5,
                    //     curve: 'smooth',
                    //     show: true,
                    // },

                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return kFormatter(value);
                            }
                        },
                    },
                    // fill: {
                    //     opacity: 1
                    // },
                    // fill: {
                    //     type: 'gradient',
                    //     gradient: {
                    //         shade: 'dark',
                    //         gradientToColors: [$themeColors.primary, $themeColors.secondary],
                    //         shadeIntensity: 1,
                    //         type: 'horizontal',
                    //         opacityFrom: 1,
                    //         opacityTo: 1,
                    //         stops: [0, 100, 100, 100]
                    //     },
                    // },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                            }
                        }
                    }
                }
            },
            columnChartAmount: {
                series: [{
                    name: 'Montant Total',
                    data: []
                },],
                chartOptions: {
                    colors: [$themeColors.success, $themeColors.secondary],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '30%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    xaxis: {
                        categories: [],
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return kFormatter(value);
                            }
                        },
                    },
                    fill: {
                        opacity: 10

                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                                return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
                            }
                        }
                    }
                }
            },
            showDataKeys: 0,
            showLoading: true,
            startDate: new Date().toISOString().split('T')[0],
            endDate: new Date().toISOString().split('T')[0],
        }
    },
    watch: {
        rangePicker(dateString) {
            if (dateString.includes("to")) {
                const dateArray = dateString.split(" to ");
                if (dateArray.length === 2) {
                    const startDate = dateArray[0];
                    const endDate = dateArray[1];
                    this.startDate = startDate;
                    this.endDate = endDate;
                    this.loadData();
                } else {
                    console.log("Invalid date format.");
                }
            } else {
                console.log("Substring 'to' not found in the string.");
            }
        }
    },
    methods: {
        async loadData() {
            this.isDataLoaded = false;
            this.columnChartNumbers.series[0].data = [];
            this.columnChartAmount.series[0].data = [];
            this.columnChartNumbers.chartOptions.xaxis.categories = [];
            this.columnChartAmount.chartOptions.xaxis.categories = [];
            this.showLoading = true;
            let filter = this.generateDateFilters();
            filter.push({
                "field": "Sell_to_Customer_No",
                "value": this.$route.params.slug,
                "operator": "eq",
                "type" : "String"
            });
            let response = await this.$http.post("order_header/findWhere", filter).catch(() => {
                this.showLoading = false;
            });
            
            const startDate = new Date(this.startDate);
            const endDate = new Date(this.endDate);
            // Calculate the time difference in milliseconds
            const timeDifference = endDate - startDate;
            // Calculate the difference in days
            const differenceInDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            if (differenceInDays < 50) {
                this.culumnChartNumbersTitle = "Variation Quotidienne des Ventes Par Nombre de Commandes";
                this.columnChartAmountTitle = "Variation Quotidienne des Ventes Par Chiffre D'affaires";
                const output = this.processOrdersGroupedByDays(response.data);
                this.columnChartNumbers.chartOptions.xaxis.categories = output.dataGroupedByDays.map(obj => obj.day);
                this.columnChartAmount.chartOptions.xaxis.categories = this.columnChartNumbers.chartOptions.xaxis.categories;
                this.columnChartNumbers.series[0].data = output.dataGroupedByDays.map(obj => obj.orderCount);
                this.columnChartAmount.series[0].data = output.dataGroupedByDays.map(obj => obj.sumAmount);
                this.showDataKeys += 1;
                this.showLoading = false;
            } else {
                this.culumnChartNumbersTitle = "Variation Mensuelle des Ventes Par Nombre de Commandes";
                this.columnChartAmountTitle = "Variation Mensuelle des Ventes Par Chiffre D'affaires";
                const output = this.processOrdersGroupedByMonth(response.data);
                this.columnChartNumbers.chartOptions.xaxis.categories = output.distinctMonths;
                this.columnChartAmount.chartOptions.xaxis.categories = output.distinctMonths;
                this.columnChartNumbers.series[0].data = output.dataGroupedByMonths.map(obj => obj.orderCount);
                this.columnChartAmount.series[0].data = output.dataGroupedByMonths.map(obj => obj.sumAmount);
                this.showDataKeys += 1;
                this.showLoading = false;
            }
        },
        generateDateFilters() {
            const filters = [
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "gt"
                },
                {
                    "field": "Posting_Date",
                    "value": "",
                    "operator": "lt"
                }
            ];
            // Convert start date string to Date and adjust by -1 day
            const startDateObj = new Date(this.startDate);
            startDateObj.setDate(startDateObj.getDate() - 1);
            // Convert end date string to Date and adjust by +1 day
            const endDateObj = new Date(this.endDate);
            endDateObj.setDate(endDateObj.getDate() + 1);
            // Format adjusted dates as strings in yyyy-MM-dd format
            const formattedStartDate = startDateObj.toISOString().split('T')[0];
            const formattedEndDate = endDateObj.toISOString().split('T')[0];
            // Set adjusted date values in the filter objects
            filters[0].value = formattedStartDate;
            filters[1].value = formattedEndDate;
            return filters;
        },
        processOrdersGroupedByDays(inputList) {
            const orders = [];

            // Step 1: Extract and parse the data
            inputList.forEach(item => {
                const postingDate = item.Posting_Date;
                const amount = parseFloat(item.Amount_Including_VAT);
                const orderNo = item.No;

                orders.push({ postingDate, amount, orderNo });
            });

            // Step 2: Group data by day and calculate sum of amount per day
            const groupedByDay = {};
            orders.forEach(order => {
                const { postingDate, amount } = order;
                if (!groupedByDay[postingDate]) {
                    groupedByDay[postingDate] = { sumAmount: 0, orderCount: 0 };
                }
                groupedByDay[postingDate].sumAmount += amount;
                groupedByDay[postingDate].orderCount++;
            });

            // Step 3: Prepare the final output with "DD Month" format
            const dataGroupedByDays = Object.keys(groupedByDay).map(day => {
                const formattedDay = new Date(day).toLocaleDateString('en-US', {
                    day: '2-digit',
                    month: 'short'
                });

                return {
                    day: formattedDay,
                    sumAmount: groupedByDay[day].sumAmount,
                    orderCount: groupedByDay[day].orderCount
                };
            });

            return {
                dataGroupedByDays,
            };
        },
        processOrdersGroupedByMonth(inputList) {
            const orders = [];

            // Step 1: Extract and parse the data
            inputList.forEach(item => {
                const postingDate = new Date(item.Posting_Date);
                const amount = parseFloat(item.Amount_Including_VAT);
                const orderNo = item.No;

                orders.push({ postingDate, amount, orderNo });
            });

            // Step 2: Group data by month and calculate sum of amount and order count per month
            const groupedByMonth = {};
            orders.forEach(order => {
                const { postingDate, amount } = order;
                const yearMonth = postingDate.toLocaleString('default', { year: 'numeric', month: 'long' });

                if (!groupedByMonth[yearMonth]) {
                    groupedByMonth[yearMonth] = { sumAmount: 0, orderCount: 0 };
                }
                groupedByMonth[yearMonth].sumAmount += amount;
                groupedByMonth[yearMonth].orderCount++;
            });

            // Step 3: Prepare the final output
            const distinctMonths = Object.keys(groupedByMonth);
            const dataGroupedByMonths = [];

            distinctMonths.forEach(month => {
                dataGroupedByMonths.push({
                    month,
                    sumAmount: groupedByMonth[month].sumAmount,
                    orderCount: groupedByMonth[month].orderCount
                });
            });

            return {
                distinctMonths,
                dataGroupedByMonths,
            };
        },
        getCurrentAndPastDay(days) {
            const currentDate = new Date();
            const pastDate = new Date();
            pastDate.setDate(pastDate.getDate() - days);

            const formattedCurrentDay = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1 + "").padStart(2, "0")}-${currentDate.getDate()}`;
            const formattedPastDay = `${pastDate.getFullYear()}-${(pastDate.getMonth() + 1 + "").padStart(2, "0")}-${pastDate.getDate()}`;

            return {
                currentDay: formattedCurrentDay,
                pastDay: formattedPastDay,
            };
        }
    },
    created() {
        let data = this.getCurrentAndPastDay(20);
        this.rangePicker[0] = data.pastDay;
        this.rangePicker[1] = data.currentDay;
        this.startDate = data.pastDay;
        this.endDate = data.currentDay;
        this.loadData();
    },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>